import { createContext, useContext } from 'react';
import { AUTH_ENABLED } from './AuthConfig';

export const AuthContext = createContext({ canEdit: !AUTH_ENABLED });
export const useEditorAccess = () => useContext(AuthContext);
